import { SINGLETON_KEY } from '#layers/base/public';
import { defineWorkspaceEntityHydration } from '#layers/runtime/public';

/** The settings singleton of a workspace runtime. */
export const workspaceSettingsHydration = defineWorkspaceEntityHydration((store) => store.MonospaceSettings.query((q) => q.first({ key: SINGLETON_KEY })), { empty: null });
